import { DateRange } from '@mui/x-date-pickers-pro';
import {
  differenceInDays,
  differenceInMonths,
  endOfMonth,
  endOfQuarter,
  startOfMonth,
  startOfQuarter,
  subDays,
  subMonths,
  subQuarters,
} from 'date-fns';

export const TODAY = new Date();

export const DEFAULT_DATE_RANGE: DateRange<Date> = [subMonths(TODAY, 12), TODAY];

export const getPreviousMonthDateRange = (referenceDate: Date): DateRange<Date> => {
  const previousMonthDate = subMonths(referenceDate, 1);
  return [startOfMonth(previousMonthDate), endOfMonth(previousMonthDate)];
};

export const getPreviousQuarterDateRange = (referenceDate: Date): DateRange<Date> => {
  const previousQuarterDate = subQuarters(referenceDate, 1);
  return [startOfQuarter(previousQuarterDate), endOfQuarter(previousQuarterDate)];
};

export const calculateReferenceDateRange = (value: DateRange<Date>): DateRange<Date> => {
  if (!value[0] || !value[1]) {
    return [null, null];
  }
  // Calculate the difference in months
  const differenceMonths = differenceInMonths(value[1], value[0]);

  // If there is a difference in months, subtract that many months
  if (differenceMonths > 0) {
    return [subMonths(value[0], differenceMonths), subMonths(value[1], differenceMonths)];
  }

  const differenceDays = differenceInDays(value[1], value[0]);
  return [subDays(value[0], differenceDays), subDays(value[1], differenceDays)];
};
